import { jsPDF } from 'jspdf';

export const generateSemesterPDF = (subjects, result, logoBase64) => {
  const doc = new jsPDF();
  
  // Set font
  doc.setFont('helvetica');
  
  // Add logo (if provided)
  if (logoBase64) {
    try {
      doc.addImage(logoBase64, 'PNG', 15, 10, 20, 20);
    } catch (e) {
      console.warn('Logo could not be added to PDF');
    }
  }
  
  // Header
  doc.setFontSize(20);
  doc.setTextColor(99, 102, 241); // Indigo
  doc.text('CUCalc', 40, 20);
  
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text('Semester GPA Report', 15, 35);
  
  // Date
  doc.setFontSize(10);
  doc.setTextColor(100, 100, 100);
  const date = new Date().toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });
  doc.text(`Generated: ${date}`, 15, 42);
  
  // Line separator
  doc.setDrawColor(200, 200, 200);
  doc.line(15, 45, 195, 45);
  
  // Subject Table Header
  let yPos = 55;
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'bold');
  doc.text('Subject', 15, yPos);
  doc.text('Credit Hours', 110, yPos);
  doc.text('GPA', 160, yPos);
  
  // Table separator
  yPos += 3;
  doc.setDrawColor(200, 200, 200);
  doc.line(15, yPos, 195, yPos);
  yPos += 8;
  
  // Subject rows
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  
  subjects.forEach((subject, index) => {
    if (!subject.creditHours && !subject.subjectGPA) return; // Skip empty rows
    
    const name = subject.name || `Subject ${index + 1}`;
    const ch = subject.creditHours || '-';
    const gpa = subject.subjectGPA || '-';
    
    doc.text(name.substring(0, 40), 15, yPos); // Limit name length
    doc.text(ch.toString(), 110, yPos);
    doc.text(gpa.toString(), 160, yPos);
    
    yPos += 8;
    
    // Add new page if needed
    if (yPos > 270) {
      doc.addPage();
      yPos = 20;
    }
  });
  
  // Summary section
  yPos += 5;
  doc.setDrawColor(200, 200, 200);
  doc.line(15, yPos, 195, yPos);
  yPos += 10;
  
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.text('Summary', 15, yPos);
  yPos += 10;
  
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  doc.text(`Total Credit Hours: ${result.totalCreditHours}`, 15, yPos);
  yPos += 8;
  
  // Final GPA - Large and prominent
  yPos += 10;
  doc.setFillColor(99, 102, 241); // Indigo background
  doc.rect(15, yPos - 5, 180, 25, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(10);
  doc.text('SEMESTER GPA', 90, yPos + 2, { align: 'center' });
  
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text(result.gpa.toFixed(2), 90, yPos + 12, { align: 'center' });
  
  // Footer
  doc.setTextColor(150, 150, 150);
  doc.setFontSize(8);
  doc.setFont('helvetica', 'italic');
  doc.text('Generated by CUCalc - COMSATS University Calculator', 105, 285, { align: 'center' });
  
  // Save PDF
  const filename = `Semester_GPA_${date.replace(/\s/g, '_')}.pdf`;
  doc.save(filename);
};
